export enum CacheStorageType {
  Local = 'local',
  Session = 'session',
}
